module.exports = __webpack_public_path__ + "img/Volleyball.7d397c95.png";